module.exports = __webpack_public_path__ + "img/mjr-eventos.6a2219af.png";